import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { JwtHelperService } from '@auth0/angular-jwt';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ChatConfigService } from 'src/app/chatbot/services/chat-config.service';
import { MappedDevicesGuard } from '../../auth/mapped-devices.guard';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit, OnDestroy {
  defaultData: any = [];
  loginForm: UntypedFormGroup;
  versionNo: any;
  helper = new JwtHelperService();
  pdummy: any;
  isTextFieldType1: boolean = false;
  private debounceTimeout: any;
  loginMode: 'local' | 'ldap' = 'local';
  isSpinner: boolean = false;
  private destroy$ = new Subject<void>();
  constructor(@Inject('apiEndPoint') private apiEndPoint: string,
    @Inject('version') private version: string,
    private formBuilder: UntypedFormBuilder, private toast: ToastrService,
    public router: Router, public service: AuthService, private config: ChatConfigService, 
    private mappedDevicesGuard: MappedDevicesGuard,
  ) { }
  // email: ['', [Validators.required, Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.minLength(3)]],
      password: ['', [Validators.required, Validators.minLength(3)]]
    });
    this.versionNo = this.version;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    clearTimeout(this.debounceTimeout);
  }

  signInWithFacebook() {
    localStorage.setItem('socialMedia', 'facebook')
    window.open(this.apiEndPoint + '/_login/facebook', "_self");
  }
  /** Local account login — called by the main Sign In button via ngSubmit */
  Submit(userLoginDetails: any): void {
    if (this.loginForm.invalid) return;
    if(userLoginDetails.email=="xedge"){
      this.toast.warning("wrong username or password");
      return;
    }
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      clearTimeout(this.debounceTimeout);
      this.isSpinner = true;
      const encryptedPassword = this.service.encryptUsingAES256(userLoginDetails.password);
      this.service.login_uibackend(userLoginDetails.email, encryptedPassword)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (resp: any) => this.handleLoginSuccess(resp),
        error: () => { this.isSpinner = false; },
      });
    }, 1000);
  }

  /** LDAP / Active Directory login — called by the "Login with LDAP / AD" button */
  loginWithLdap(userLoginDetails: any): void {
    if (this.loginForm.invalid) return;
    this.isSpinner = true;
    const encryptedPassword = this.service.encryptUsingAES256(userLoginDetails.password);
    this.service.ldapLogin(userLoginDetails.email, encryptedPassword)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (resp: any) => this.handleLoginSuccess(resp),
        error: () => { this.isSpinner = false; },
      });
  }

  private handleLoginSuccess(resp: any) {
    if (resp?.result?.jwt) {
      this.config.refreshChatbotVisibility();
      this.config.resetController();
      this.config.ensureControllerId();   // pre-warm so first toggle() is instant
      window.localStorage.setItem('user_id', resp.result._id);
      window.localStorage.setItem('token', resp.result.jwt);
      this.mappedDevicesGuard.refresh().pipe(takeUntil(this.destroy$)).subscribe();
      this.service.getUserDetails().pipe(takeUntil(this.destroy$))
        .subscribe((user: any) => {
        const profileid = user.result?._source?.user_type || 'user';
        window.localStorage.setItem('full_name', user.result._source.fullname);
        window.localStorage.setItem('thresholds', JSON.stringify(user.result._source.thresholds));
        window.localStorage.setItem('user_type', user.result._source.user_type);
        window.localStorage.setItem('user_devices', JSON.stringify(user.result._source?.devices));
        localStorage.setItem('startegy', user.result.strategies[0]);
        this.service.getRoleDetails(profileid).pipe(takeUntil(this.destroy$))
        .subscribe((role: any) => {
          window.localStorage.setItem('sideMenuList', JSON.stringify(role.result._source.pages));
          this.isSpinner = false;
          this.toast.success('Login Successful');
          this.router.navigate(['/dashboard']);
          this.service.getPageNameData('Home');
          const time = moment.utc().valueOf();
          const time_local = moment().valueOf();
          const timeZone = moment.tz.guess();
          this.service.createLoginEventNotification(user.result?._source?.fullname, user.result?._id, time, timeZone, user.result?._source?.user_type, 'INFO', 'Login', time_local)
            .subscribe(() => {});
        });
      });
    } else {
      this.isSpinner = false;
      this.toast.error('Login failed. Please check your credentials.');
    }
  }
  handleEncrypt(value) {
    return this.service.encryptUsingAES256(value)
  }
  handleDecrypt() {
    // console.log(this.service.decrypt(this.pdummy));
  }
  togglePasswordFieldType() {  // for view password
    this.isTextFieldType1 = !this.isTextFieldType1;
  }

  getTimeData(){
    let time = moment.utc().valueOf();
    let timeZone = moment()?.['_d'];
  }
}